module.exports = __webpack_public_path__ + "img/6.0b2facc8.png";